import Api from 'requestapijs';
import { BehaviorSubject } from 'rxjs';
import { LOGIN_URL, HEADER, API_URL } from '../config';
import { UserDetailNode, UserDetailMutationInput, UserDetailMutationPayload } from '../../schema';
import { queryString, mutation } from '../components/User/constant';

export class UserService {
  static instance: UserService;
  public readonly user$ = new BehaviorSubject<UserDetailNode>(null);
  private readonly token = localStorage.getItem('token');

  constructor() {
    if (UserService.instance) {
      return UserService.instance;
    } else {
      UserService.instance = this;
    }
    this.init();
  }

  init() {
    if (localStorage.token) {
      Api.graphql<{}, any>(
        API_URL,
        { user_AuthToken: localStorage.token.replace('Token ', '') },
        queryString,
        HEADER,
        (response) => {
          this.user$.next(response.data.allUserDetails.edges[0].node);
        },
        (error) => error,
      );
    }
  }

  login(data, onSuccess?: (onSuccess: UserDetailNode) => void, onError?: (error: any) => void) {
    Api.post(LOGIN_URL, data, HEADER).subscribe(
      (response) => {
        localStorage.setItem('token', `Token ${response.response.token}`);
        this.init();
        onSuccess && onSuccess(response.response);
      },
      (error) => onError && onError(error),
    );
  }

  logout() {
    window.location.href = '/';
    localStorage.removeItem('token');
  }

  addUserDetail(data: UserDetailMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    Api.graphql<{ input: UserDetailMutationInput }, UserDetailMutationPayload>(
      API_URL,
      { input: data },
      mutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (response) => {
        onError(response);
      },
    );
  }
}
